var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.524,
    height: 37.406,
    viewBox: "0 0 191.524 37.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2431",
    "data-name": "Group 2431",
    transform: "translate(3206 -9044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M73.007,10.287v9.356a5.427,5.427,0,0,1-.731,3.147,2.667,2.667,0,0,1-2.3,1,2.77,2.77,0,0,1-2.362-1.021,5.246,5.246,0,0,1-.763-3.126v-9.1H61.867v9.1a5.238,5.238,0,0,1-.764,3.126,2.768,2.768,0,0,1-2.362,1.021,2.648,2.648,0,0,1-2.3-1,5.339,5.339,0,0,1-.733-3.147V10.287H50.727v9.737a8.015,8.015,0,0,0,2.041,5.87,7.926,7.926,0,0,0,5.9,2.073A8.74,8.74,0,0,0,61.99,27.4a5.446,5.446,0,0,0,2.363-1.857A5.491,5.491,0,0,0,66.735,27.4a8.693,8.693,0,0,0,3.27.567,8,8,0,0,0,5.911-2.073,7.945,7.945,0,0,0,2.074-5.87V10.287Z",
    transform: "translate(-3204.402 9044.325)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M97.44,20.542s.072-1.176.072-1.568a8.7,8.7,0,0,0-1.2-4.652,8.091,8.091,0,0,0-3.208-3,9.591,9.591,0,0,0-4.466-1.032,9.772,9.772,0,0,0-4.714,1.135,8.42,8.42,0,0,0-3.29,3.156,8.812,8.812,0,0,0-1.2,4.549,8.723,8.723,0,0,0,1.217,4.57A8.356,8.356,0,0,0,84.1,26.845a11.283,11.283,0,0,0,5.147,1.124,9.284,9.284,0,0,0,6.426-2.115l-1.609-1.609-.01-.01c-.113-.113-1-1.011-1.217-1.217a6.15,6.15,0,0,1-.722.4c-.165.072-.3.134-.371.165a6.5,6.5,0,0,1-2.372.4,6.016,6.016,0,0,1-2.857-.64c-.629-.32-2.053-1.537-2.053-2.806ZM84.463,17.468v-.01a4.27,4.27,0,0,1,.887-1.929,1.768,1.768,0,0,1,.227-.258,4.056,4.056,0,0,1,3.064-1.217,4.36,4.36,0,0,1,2.62.794,3.554,3.554,0,0,1,1.506,2.62Z",
    transform: "translate(-3203.497 9044.324)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M123.665,3.589a3.272,3.272,0,0,0-2.238-.763,3.193,3.193,0,0,0-2.238.794,2.624,2.624,0,0,0-.856,1.982,2.592,2.592,0,0,0,.856,1.98,3.5,3.5,0,0,0,4.477-.01,2.754,2.754,0,0,0,.856-2.063,2.494,2.494,0,0,0-.856-1.92m-4.724,24.365h4.972V10.779h-4.972Z",
    transform: "translate(-3202.272 9044.09)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M143.144,12.206a7.073,7.073,0,0,0-5.158-1.919,8.589,8.589,0,0,0-3.218.588,6.637,6.637,0,0,0-2.465,1.681l-4.755-2.011V27.72h4.982v-8.5a4.817,4.817,0,0,1,1.114-3.456,3.932,3.932,0,0,1,3-1.166,3.291,3.291,0,0,1,2.589,1,4.479,4.479,0,0,1,.9,3.053V27.72H145.1V17.889q0-3.775-1.96-5.684",
    transform: "translate(-3201.982 9044.325)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M153.116,3.589a3.272,3.272,0,0,0-2.238-.763,3.193,3.193,0,0,0-2.238.794,2.624,2.624,0,0,0-.856,1.982,2.592,2.592,0,0,0,.856,1.98,3.5,3.5,0,0,0,4.477-.01,2.754,2.754,0,0,0,.856-2.063,2.494,2.494,0,0,0-.856-1.92m-4.724,24.365h4.982V10.779h-4.982Z",
    transform: "translate(-3201.344 9044.09)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M166.138,23.578a3.456,3.456,0,0,1-2.042.64,2,2,0,0,1-1.568-.6,2.376,2.376,0,0,1-.536-1.671V14.573h4.239V10.745h-4.239V3.91h-4.982v18.1a6.036,6.036,0,0,0,1.661,4.6,6.671,6.671,0,0,0,4.755,1.558,8.766,8.766,0,0,0,2.218-.268,5.016,5.016,0,0,0,1.805-.815Z",
    transform: "translate(-3201.053 9044.123)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M181.228,10.537v7.437a4.95,4.95,0,0,1-1.083,3.466,3.751,3.751,0,0,1-2.878,1.167c-2.321,0-3.476-1.4-3.476-4.189V10.537h-4.982V19.15q0,3.87,1.98,5.8a7.339,7.339,0,0,0,5.364,1.929,7.616,7.616,0,0,0,2.806-.505,6.5,6.5,0,0,0,2.269-1.475v.578a4.812,4.812,0,0,1-1.145,3.517,5,5,0,0,1-3.641,1.145,10.176,10.176,0,0,1-3.167-.516,8.1,8.1,0,0,1-2.651-1.4l-1.97,3.579a10.4,10.4,0,0,0,3.621,1.754,16.883,16.883,0,0,0,4.58.609q4.564,0,6.963-2.3c1.589-1.537,2.393-3.868,2.393-7.025v-14.3Z",
    transform: "translate(-3200.687 9044.333)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M108.085,10.487a8.763,8.763,0,0,0-4.085,1V3.91H99.245V19.328a8.84,8.84,0,1,0,8.84-8.841m0,13.39A4.35,4.35,0,0,1,104,20.8a4.7,4.7,0,0,1,0-2.95,4.347,4.347,0,0,1,4.085-3.084,4.442,4.442,0,0,1,4.322,4.559,4.44,4.44,0,0,1-4.322,4.549",
    transform: "translate(-3202.874 9044.123)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M24.557,37.026l-12.47-12.47,12.47-12.469Z",
    transform: "translate(-3205.619 9044.381)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M36.647,0V24.938h0L24.176,37.4V12.467Z",
    transform: "translate(-3205.239 9044)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M12.467,0V24.938L0,37.4V12.467Z",
    transform: "translate(-3206 9044)",
    fill: "#9734eb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ab9b6cfba2225fe2df5442ef0232da8.svg";
export { ForwardRef as ReactComponent };